import { useMemo } from 'react';
import { HubBasePage } from '../../../../../types';
import {
  DiscoveryContentTypes,
  InformaMetaTagPageType,
} from '../../../../../constants';
import { useRootSelector } from '../../../../../store/hooks';
import { selectBrandHubPage } from '../../store/features/page';
import { selectBrandHubOptions } from '../../store/features/options';
import {
  selectHubDiscoveryArticleRecord,
  selectHubDiscoveryFacets,
  DiscoveryArticle,
  HubPageNames,
  SortTypes,
} from '../../../../../store/features/discovery';
import PageLayout from '../../layouts/PageLayout';
import { MetaTags } from '../../../shared/MetaTags';
import { ArticleCard } from '../../../shared/productFilter/cards';
import { AggregatedProductPage } from '../../../shared/siteBuilder/AggregatedProductPage';

export function Articles() {
  const {
    data: {
      page: {
        details: { title, description, metaDescription, searchQueryData },
      },
      header: {
        headerNavBar: { brandLogo },
      },
    },
  } = useRootSelector(selectBrandHubPage<HubBasePage>());
  const {
    data: { name: hubName, subBrandName: brandName },
  } = useRootSelector(selectBrandHubOptions);
  const facets = useRootSelector(selectHubDiscoveryFacets);
  const record = useRootSelector(selectHubDiscoveryArticleRecord);
  const heading = title || 'News & Insights';

  const defaultValues = useMemo(
    () => ({
      subBrands: [brandName],
      sectors: [],
      topics: [],
      articleTypes: [],
      availableSubBrands: [brandName],
      requestedSortType: SortTypes.FEATURED,
      page: 1,
      count: 20,
      searchInput: '',
      type: [DiscoveryContentTypes.ARTICLE],
    }),
    [brandName],
  );

  return (
    <PageLayout>
      <MetaTags
        informaPageType={InformaMetaTagPageType.BasePage}
        informaPageId={HubPageNames.articles}
        thumbnail={brandLogo?.path}
        description={metaDescription}
        titleSuffix={hubName}
        title={heading}
      />
      <AggregatedProductPage<DiscoveryArticle>
        searchQueryData={searchQueryData}
        defaultValues={defaultValues}
        renderProduct={(product) => (
          <ArticleCard cardType="list" data={product} />
        )}
        record={record}
        facets={facets}
        subtitle={description}
        title={heading}
        contentType={DiscoveryContentTypes.ARTICLE}
        pageName={HubPageNames.articles}
      />
    </PageLayout>
  );
}
